import type { FC } from "react"

import CompanyWideToggleDropdown from "./toggle-dropdown/CompanyWideToggleDropdown"
import styles from "./CompanyWideRow.module.scss"

import {
	type FragmentType,
	getFragmentData,
} from "@/souhl_admin/gql/__generated__"
import { graphql } from "@/souhl_admin/gql/__generated__/gql"

import type { FlagEditState } from "../useFeatureFlagTab"

const CompanyWideRowCompanyFeatureFlagFragment = graphql(/* GraphQL */ `
	fragment CompanyWideRowCompanyFeatureFlag on CompanyFeatureFlag {
		featureFlag {
			id
		}
	}
`)

type Props = {
	companyFeatureFlags: FragmentType<
		typeof CompanyWideRowCompanyFeatureFlagFragment
	>[]
	flagStates: Record<string, FlagEditState>
	openDropdownFlagId: string | null
	onToggleDropdown: (flagId: string) => void
	onSelect: (flagId: string, enabled: boolean) => void
}

const CompanyWideRow: FC<Props> = ({
	companyFeatureFlags,
	flagStates,
	openDropdownFlagId,
	onToggleDropdown,
	onSelect,
}) => {
	const cfs = companyFeatureFlags.map((cf) =>
		getFragmentData(CompanyWideRowCompanyFeatureFlagFragment, cf)
	)

	return (
		<tr className={styles.companyWideRow}>
			<td className={styles.labelTd}>
				<span className={styles.companyWideLabel}>設定方法</span>
			</td>
			{cfs.map((cf) => {
				const state = flagStates[cf.featureFlag.id]
				const isEnabled = state?.companyWide ?? false
				const isOpen = openDropdownFlagId === cf.featureFlag.id
				return (
					<td key={cf.featureFlag.id} className={styles.flagTd}>
						<CompanyWideToggleDropdown
							flagId={cf.featureFlag.id}
							isEnabled={isEnabled}
							isOpen={isOpen}
							onToggleOpen={onToggleDropdown}
							onSelect={onSelect}
						/>
					</td>
				)
			})}
		</tr>
	)
}

export default CompanyWideRow
